import { render, staticRenderFns } from "./UserTreeItem.vue?vue&type=template&id=ad4e9724"
import script from "./UserTreeItem.vue?vue&type=script&lang=js"
export * from "./UserTreeItem.vue?vue&type=script&lang=js"
import style0 from "./UserTreeItem.vue?vue&type=style&index=0&id=ad4e9724&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports